export enum LocationType {
  CCWS,
  Scheduler,
  Standard
}
